import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ButtonIcon } from '../../../../../../common/APICommon';


export function CategoryHeader({
  category,
  expanded,
  getCategoryIcon,
  getCategoryColor,
  onToggle,
  onEdit,
  onDelete,
  calculateObjectivesTotal
}) {
  const objectivesTotal = calculateObjectivesTotal(category.objectives);
  const remainingPercentage = (parseFloat(category.totalPercentage) || 0) - objectivesTotal;

  return (
    <tr
      className={`cursor-pointer transition-colors hover:bg-gray-50 ${getCategoryColor(category.id)} border-l-4`}
      onClick={() => onToggle(category.id)}
    >
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center space-x-3">
          <div className="flex items-center">
            {expanded ? (
              <ExpandMoreIcon className="!w-4 !h-4 text-gray-500 mr-2" />
            ) : (
              <ChevronRightIcon className="!w-4 !h-4 text-gray-500 mr-2" />
            )}
            {getCategoryIcon(category.id)}
          </div>
          <div>
            <div className="font-semibold text-gray-900">{category.description}</div>
            <div className="text-sm text-gray-500">
              {category.objectives?.length || 0} objective{(category.objectives?.length || 0) !== 1 ? 's' : ''}
              {remainingPercentage > 0 && ` • ${remainingPercentage.toFixed(2)}% available`}
            </div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className="text-sm text-gray-500">Category</span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className="px-3 py-1.5 rounded-full text-sm font-semibold bg-blue-100 text-blue-800">
          {category.totalPercentage}%
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex space-x-2">
          <ButtonIcon
            icon={<EditIcon />}
            className={"bg-blue-500 hover:bg-blue-600 border-none cursor-pointer"}
            onClick={(e) => {
              e.stopPropagation();
              onEdit(category);
            }}
          />
          <ButtonIcon
            icon={<DeleteIcon />}
            className={"bg-red-500 hover:bg-red-600 border-none cursor-pointer"}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(category.id);
            }}
          />
        </div>
      </td>
    </tr>
  );
}